import { throwUserFacingHttpError } from "lib/utils/userFacingApiError";
import { getNav2ParamsApiBaseUrl } from "lib/nav2ParamsApi";
import { joinUrl } from "lib/utils/connection";
import { getAuthToken } from "lib/utils/auth";
import { authedFetch } from "lib/utils/authedFetch";

export type Nav2LogsTailResponse = {
    service: string;
    lines: string[];
    count: number;
};

async function parseError(res: Response): Promise<string> {
    let detail = `HTTP ${res.status}`;
    try {
        const body = (await res.json()) as { detail?: unknown };
        const d = body?.detail;
        if (typeof d === "string") detail = d;
    } catch {
        /* ignore */
    }
    return detail;
}

/**
 * SSE URL for nav.service journal follow.
 * EventSource cannot set Authorization; arc_auth accepts the ARC JWT as `?token=`.
 */
export function getNav2LogsStreamUrl(
    selectedArcHost?: string | null,
    isSecure?: boolean,
    arcId?: string | null
): string | null {
    const base = getNav2ParamsApiBaseUrl(selectedArcHost, isSecure, arcId);
    if (!base) return null;
    const url = new URL(joinUrl(base, "/nav2/nav/logs/stream"));
    const token = getAuthToken();
    if (token) url.searchParams.set("token", token);
    return url.toString();
}

export async function fetchNav2LogsTail(
    baseUrl: string,
    lines: number = 200
): Promise<Nav2LogsTailResponse> {
    const url = new URL(joinUrl(baseUrl, "/nav2/nav/logs/tail"));
    url.searchParams.set("lines", String(lines));
    const res = await authedFetch(url.toString());
    if (!res.ok) throw new Error(await parseError(res));
    return res.json() as Promise<Nav2LogsTailResponse>;
}
